import { LIGHT_CONDITION } from '../utils/constantes';

/**
 * The default format request.
 * @type {string}
 */
export const DEFAULT_FORMAT = 'image/png';

/**
 * The default style request.
 * @type {string}
 */
export const DEFAULT_STYLE = 'default';

/**
 * The default light condition.
 * @type {string}
 */
export const DEFAULT_LIGHT_CONDITION = LIGHT_CONDITION.DAY;

/**
 * The layers parameter name.
 * @type {string}
 */
export const LAYERS_PARAM = 'LAYERS';

/**
 * The light condition parameter name.
 * @type {string}
 */
export const LIGHT_CONDITION_PARAM = 'LIGHT_CONDITION';
/**
 * The databse version parameter name
 * @type {string}
 */
export const DATABASE_VERSION_PARAM = 'DB_VERSION';
/**
 * The WMS protocol version parameter name
 * @type {string}
 */
export const WMS_VERSION_PARAM = 'VERSION';
/**
 * The WMS protocol version value
 * @type {string}
 */
export const DEFAULT_WMS_VERSION = '1.1.1';
